import { ReactElement } from "react";
import { useState } from "react";
import { ParameterValue } from "calculation/parameter";
import { useEffect } from "react";
import { ParameterDefaultValueDto } from "dtos/dtos";

export function ParameterInput({
  parameterValue,
  parameterDefaultValue,
  disabled = false,
  onChange
}: {
  parameterValue: ParameterValue;
  parameterDefaultValue: ParameterDefaultValueDto | undefined;
  disabled?: boolean;
  onChange: () => void;
}): ReactElement {
  function updateValue(e: any) {
    if (e.target.value !== "") {
      const value = Math.max(Math.min(1, parseFloat(e.target.value)), 0);
      parameterValue.value = value;
      parameterValue.displayValue = e.target.value;
      setValue(value);
    } else {
      setValue(parameterValue.defaultValue);
    }

    onChange();
  }

  function resetToDefaultValue(e: any) {
    if (parameterDefaultValue !== undefined) {
      parameterValue.value = parameterDefaultValue.value;
      setValue(parameterValue.value);
    }
  }

  const [value, setValue] = useState<number>(0);

  useEffect(() => {
    setValue(parameterValue.value);
  }, [parameterValue]);

  return (
    <div className="flex flex-row items-center space-x-4">
      <input
        type="number"
        min="0"
        max="1"
        placeholder="Wert von 0 bis 1"
        value={value}
        step="0.01"
        required={true}
        onChange={updateValue}
        disabled={disabled}
        className={`border-2 border-gray-200 focus:border-blue-400 focus:ring-0 text-gray-600 w-56 py-1 ${
          disabled
            ? "text-gray-400 border-gray-200"
            : value === parameterDefaultValue?.value
            ? "text-gray-600 border-gray-300"
            : "text-orange-300 border-gray-300"
        }`}
      />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${
          disabled ? "hidden" : ""
        } w-6 h-6 cursor-pointer text-gray-400`}
        onClick={resetToDefaultValue}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
    </div>
  );
}
